import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useCallback, useMemo, useEffect } from 'react';
import { useForm } from 'antd/lib/form/Form';
export var useHeadingForm = function useHeadingForm(_ref) {
  var heading = _ref.heading,
      localTitle = _ref.localTitle,
      localDescription = _ref.localDescription,
      headingLabel = _ref.headingLabel,
      onUpdateHeading = _ref.onUpdateHeading,
      isEditing = _ref.isEditing;

  var _useForm = useForm(),
      _useForm2 = _slicedToArray(_useForm, 1),
      form = _useForm2[0]; // Reset form when entering edit mode (giống logic cũ)


  useEffect(function () {
    if (isEditing) {
      // Reset the form first to clear any previous values
      form.resetFields(); // Explicitly set the form values with a slight delay to ensure the DOM is ready

      setTimeout(function () {
        form.setFieldsValue({
          title: heading.title,
          description: heading.description
        });
      }, 50);
    }
  }, [isEditing, heading, form]);
  var handleHeadingTitleFocus = useCallback(function (inputValue) {
    var defaultTitleText = "".concat((headingLabel === null || headingLabel === void 0 ? void 0 : headingLabel.defaultHeadingTitle) || '');
    var isDefaultTitleText = inputValue === defaultTitleText;

    if (isDefaultTitleText) {
      form.setFieldsValue({
        title: ''
      });
    }
  }, [headingLabel, form]);
  var handleHeadingTitleBlur = useCallback(function (inputValue) {
    var isEmptyInputValue = !inputValue.length;

    if (isEmptyInputValue) {
      var defaultTitleText = "".concat((headingLabel === null || headingLabel === void 0 ? void 0 : headingLabel.defaultHeadingTitle) || '');
      form.setFieldsValue({
        title: defaultTitleText
      });
      onUpdateHeading === null || onUpdateHeading === void 0 ? void 0 : onUpdateHeading('title', defaultTitleText);
    }
  }, [headingLabel, form, onUpdateHeading]);
  var onFieldsChange = useCallback(function (e) {
    var _e = _slicedToArray(e, 1),
        infoChange = _e[0];

    if (!infoChange) return;
    var name = infoChange.name,
        value = infoChange.value;

    var _name = _slicedToArray(name, 1),
        field = _name[0];

    onUpdateHeading === null || onUpdateHeading === void 0 ? void 0 : onUpdateHeading(field, value);
  }, [onUpdateHeading]);
  var initialValues = useMemo(function () {
    return _objectSpread(_objectSpread({}, heading), {}, {
      title: localTitle,
      description: localDescription
    });
  }, [heading, localTitle, localDescription]);
  return {
    form: form,
    initialValues: initialValues,
    handleHeadingTitleFocus: handleHeadingTitleFocus,
    handleHeadingTitleBlur: handleHeadingTitleBlur,
    onFieldsChange: onFieldsChange
  };
};